import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import store from './store/index.js'
import VueTelInput from 'vue-tel-input'
import moment from 'moment'
import VueProgress from 'vue-progress'
import Vuelidate from 'vuelidate'
import Notifications from 'vue-notification'
import VueClipboard from 'vue-clipboard2'
import { BootstrapVue } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueTypedJs from 'vue-typed-js'


// custom packages
import './utilities/filters';
import './utilities/ErrorHandler';
import Auth from './utilities/Auth'
Vue.use(BootstrapVue)
Vue.use(VueTypedJs)

// multiselect input plugin
require('vue-multiselect/dist/vue-multiselect.min.css');

// N-Progress Loading Indicator
NProgress.configure({ showSpinner: true });
NProgress.configure({ easing: 'ease', speed: 1000 });

VueClipboard.config.autoSetContainer = true;

Vue.use(VueClipboard)
Vue.use(Vuelidate)
Vue.use(VueProgress)
Vue.use(VueTelInput)
Vue.use(Notifications)
Vue.prototype.$axios = axios


window.moment = moment;

window.axios = axios

// axios.defaults.baseURL = 'https://api.moneypool.vesicash.com/v1';
// axios.defaults.headers.Authorization = 'Bearer' + localStorage.getItem('access_token');
// axios.defaults.headers.post['Content-Type'] = 'application/json';


// request interceptor
axios.interceptors.request.use(function (config) {

  NProgress.start()  //page loader

  const token = Auth.getToken();
  
  if (token != null) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  return config;
}, function (err) {
  return Promise.reject(err);
});


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
